import TreeItem from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { MinusSquare, PlusSquare } from './Icons';


export function TransitionComponent(props) {
    const style = {};
    return (
      <Collapse {...props} />
    );
  }
   
export const StyledTreeItem = withStyles((theme) => ({
    
    iconContainer: {
      '& .close': {
        opacity: 0.3,
      },
    },
    group: {
      marginLeft: 7,
      paddingLeft: 18,
      borderLeft: `1px solid `,
      '& :hover': {
        backhgroundColor: '#6783a0'
      }
    },
  
    label : {
      //  padding: 10,
       marginLeft: 30,
       border: `1px dashed #ccc`,
       marginTop: 10  ,
       
       '& :hover': {
            backhgroundColor: '#6783a0'
       }
    }
  
  }))((props) => 
  <TreeItem 
    {...props} 
    TransitionComponent={TransitionComponent} 
    collapseIcon={<MinusSquare id={`collapse_${props.messageName}`} onClick={() => props?.collapseNode(props.nodeId) } />} 
    expandIcon={<PlusSquare id={`expand_${props.messageName}`} onClick={() => props?.expandNode(props.nodeId) } />}     
  />);
  
export const useStyles = makeStyles({
    root: {
      height: 264,
      flexGrow: 2,
      maxWidth: 400,
    },
  });